import { render } from "./GoogleLoginButton.vue?vue&type=template&id=38cb0660&scoped=true"
import script from "./GoogleLoginButton.vue?vue&type=script&lang=js"
export * from "./GoogleLoginButton.vue?vue&type=script&lang=js"

import "./GoogleLoginButton.vue?vue&type=style&index=0&id=38cb0660&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cb0660"]])

export default __exports__